import {
  ลวดหนาม,
  ลวดหนาม2,
  ลวดหนาม3,
  ตะปู,
  ตะปู2,
  รั้วแรงดึง,
  รั้วแรงดึง2,
  รั้วแรงดึง3,
  ตาข่ายสาน,
  ตาข่ายสาน2,
  ตาข่ายสาน3,
  ปลอกเสาปลอกคาน,
  ปลอกเสาปลอกคาน2,
  ปลอกเสาปลอกคาน3,
  ลวดตาข่ายทอ,
  ลวดตาข่ายทอ2,
  ลวดตาข่ายทอ3,
  กรงไก่,
  กรงไก่2,
  กรงไก่3,
  กิ๊บลวดหนาม3,
  ปลอกสี่เหลี่ยม,
  ปลอกสี่เหลี่ยม2,
  ปลอกสามเหลี่ยม,
  ปลอกสามเหลี่ยม2,
  เสาเอ็นทับหลัง,
  เสาเอ็นทับหลัง2,
  เสาเอ็นทับหลัง3,
  ลวดตะปู,
  ลวดตะปู2,
  ลวดตะปู3,
  เหล็กวงบ่อ,
  เหล็กวงท่อ,
  ลวดผูกเหล็ก,
  ลวดผูกเหล็ก1,
  ลวดผูกเหล็ก2,
  เหล็กปลอกราง,
  เหล็กปลอกราง2,
  ลวดชุบสังกะสี,
  ลวดชุบสังกะสี2,
  ลวดชุบสังกะสี3,
  ลวดชุบสังกะสี4,
  ตะแกรงเหล็กฉีก,
  เหล็กเพลท,
  เหล็กเพลท2,
  เหล็กเพลท3,
  รั้วไวร์เมช,
  ตะแกรงไวร์เมช,
  สังกะสีแผ่นเรียบ,
  หนวดกุ้ง,
  เหล็กจ๊อย,
  เหล็ก2หุนลาย,
  ไวร์รอท,
  เหล็กนั่งร้าน,
  กล่องเกเบี้ยน,
  ลวดPC,
  แบบเหล็ก,

  B1,
  B2,
  B3,
  B4,
  B5,
  B6,
  B7,
  ตารางไซส์ลวด,
  ตารางไซส์ลวดชุบ,
  ตารางเหล็กเพลท,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1,
    title: "หน้าแรก",
    link: "/",
  },
  {
    _id: 2,
    title: "สินค้า",
    link: "/shop",
  },
  {
    _id: 3,
    title: "เกี่ยวกับบริษัท",
    link: "/about",
  },
  {
    _id: 4,
    title: "ติดต่อสอบถาม",
    link: "/contact",
  },
];
// =================== NavBarList End here ======================

export const bestSellers = [
  {
    _id: "1",
    img: B1,
    productName: "กิ๊บลวดหนาม",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "2",
    img: B2,
    productName: "ปลอกสี่เหลี่ยม (วัตถุดิบ มอก.)",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "3",
    img: B3,
    productName: "ปลอกสามเหลี่ยม (วัตถุดิบ มอก.)",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "4",
    img: B4,
    productName: "ลวดหนาม",
    cat: "ลวดหนาม Barbed wire",
  },
  {
    _id: "5",
    img: B5,
    productName: "ปลอกเสา-ปลอกคาน (วัตถุดิบ มอก.)",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "6",
    img: B6,
    productName: "ลวดตาข่ายทอ (ตาข่ายข้าวหลามตัด)",
    cat: "ตาข่ายทอ chain link",
  },
  {
    _id: "7",
    img: B7,
    productName: "ตาข่ายสานหยิก (ตาข่ายตัวหนอน)",
    cat: "ลวดตาข่ายต่างๆ",
  },
];

// =================== สินค้าทั้งหมด ===============================

export const allproduct = [
  {
    _id: "1",
    img: ลวดตาข่ายทอ2,
    img2: ตารางไซส์ลวด,
    img3: ลวดตาข่ายทอ2,
    img4: ลวดตาข่ายทอ3,
    productName: "ลวดตาข่ายทอ (ตาข่ายข้าวหลามตัด)",
    description: "ลวดตาข่ายทอ คือ ตาข่ายที่ใช้เหล็กลวดมาถักกันเป็นช่องๆ โดยแต่ละช่องของตะแกรงจะถักเป็นรูปสี่เหลี่ยมขนมเปียกปูน จึงเรียกได้หลายชื่อ เช่น ตาข่ายถัก,ตะแกรงถัก,ตาข่ายสี่เหลี่ยมขนมเปียกปูนถักร้อยเป็นเกลียว ตาสี่เหลี่ยมขนมเปียกปูนนั่นเอง",
    cat: "ตาข่ายทอ chain link",
  },
  {
    _id: "2",
    img: ตาข่ายสาน3,
    img2: ตารางไซส์ลวด,
    img3: ตาข่ายสาน2,
    img4: ตาข่ายสาน3,
    productName: "ตาข่ายสานหยิก (ตาข่ายตัวหนอน)",
    description: "ตาข่ายลวดสานเกิดจากการนำลวดเป็นม้วนซึ่งเป็นลวดตรง มาเข้าเครื่องบดลวดให้เป็นหยักคล้ายเส้นมาม่า แล้วตัดออกเมื่อได้ตามขนาดที่ต้องการ หลังจากนั้นจึงนำลวดที่หยิกเป็นเส้นๆเหล่านี้มาสานเข้ากันเป็นตาข่ายลวดสานโดยที่อาจเข้าเครื่องสานหรือใช้มือคนสานก็ได้",
    cat: "ลวดตาข่ายต่างๆ",
  },
  {
    _id: "3",
    img: กรงไก่,
    img2: ตารางไซส์ลวด,
    img3: กรงไก่2,
    img4: กรงไก่3,
    productName: "ตาข่ายสี่เหลี่ยม (กรงไก่)",
    description: "ลวดตาข่ายกรงไก่ คือ ลวดตาข่ายตาสี่เหลี่ยมลวดที่มีการนำเอาเส้นลวดมาขึ้นรูปด้วยเครื่องจักรและนำมาเชื่อมให้ได้ขนาดตามช่องที่ต้องการ หลังจากนั้นนำแผ่นตาข่ายไปเข้ากระบวนการชุบกัลวาไนซ์ หรือ ชุบสังกะสี โดยปกติแล้วจะนำมาใช้งานทำเป็นกรงล้อมไก่ ล้อมสัตว์",
    des: '- ตา 1/2" (4 หุน)',
    des2: '- ตา 3/4" (6 หุน)',
    des3: '- ตา 1" (1 นิ้ว)',
    cat: "ลวดตาข่ายต่างๆ",
  },
  {
    _id: "6",
    img: ลวดหนาม,
    img2: ตารางไซส์ลวด,
    img3: ลวดหนาม2,
    img4: ลวดหนาม3,
    productName: "ลวดหนาม",
    description: "ลวดหนาม คือ เส้นลวดตีเกลียวที่มีหนามแหลมคม เกิดจากการขึ้นรูปพันเป็นเกลียวของเส้นลวดชุบสังกะสี ใช้เพื่อเพิ่มความปลอดภัยและป้องกันการบุกรุกในพื้นที่ที่ต้องการรักษาความปลอดภัย",
    cat: "ลวดหนาม Barbed wire",
  },
  {
    _id: "7",
    img: กิ๊บลวดหนาม3,
    productName: "กิ๊บลวดหนาม",
    description: "กิ๊บลวดหนาม เป็นกิ๊บทรงวีสำหรับใช้ยึดรั้วลวดหนามกับเสารั้ว โดยนิยมตอกเข้าไปในรูเสาปูนหรือคอนกรีต ดัดใช้งานง่าย ยึดล็อกลวดหนามได้ดี ทนต่อแรงดึง ไม่หลุดง่าย",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "8",
    img: ปลอกเสาปลอกคาน2,
    img2: ตารางไซส์ลวด,
    img3: ปลอกเสาปลอกคาน2,
    img4: ปลอกเสาปลอกคาน3,
    productName: "ปลอกเสา-ปลอกคาน (วัตถุดิบ มอก.)",
    description: "เหล็กปลอกเสา ปลอกคาน เป็นวัสดุก่อสร้างชนิดหนึ่งที่มีการผลิตจากเหล็กเส้นกลมหรือเหล็กเส้นข้ออ้อยที่มีกำลังดึงสูง นำมาดัดโค้งเป็นรูปทรงต่างๆ เพื่อเสริมความแข็งแรงให้กับคอนกรีต ช่วยให้คอนกรีตสามารถรับแรงกดและแรงดึงได้ดียิ่งขึ้น",
    des: "- 2 หุน",
    des2: "- 3 หุน",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "9",
    img: ปลอกสามเหลี่ยม,
    img2: ตารางไซส์ลวด,
    img3: ปลอกสามเหลี่ยม2,
    img4: ปลอกเสาปลอกคาน3,
    productName: "ปลอกสามเหลี่ยม (วัตถุดิบ มอก.)",
    description : "เหล็กปลอก คือ เหล็กที่ใช้เสริมอยู่ภายในเสาหรือคานในโครงสร้างคอนกรีตเสริมเหล็ก เหล็กที่ใช้ผลิตส่วนมากคือเหล็กเส้นกลมโดยจะดัดเหล็กเส้นเป็นรูปร่างเดียวกับพื้นที่หน้าตัดของเสาหรือคานที่จะใช้ มีลักษณะเป็นเส้นกลมผิวเรียบสามารถทำเป็นรูปทรงตามที่ลูกค้าต้องการได้ เช่น สามเหลี่ยม สี่เหลี่ยม ห้าเหลี่ยม หกเหลี่ยม วงกลม รูปตัวไอ ช่วยลดเวลา ลดแรงงาน ลดค่าใช้จ่ายได้อย่างมีประสิทธิภาพ",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "10",
    img: ปลอกสี่เหลี่ยม,
    img2: ตารางไซส์ลวด,
    img3: ปลอกสี่เหลี่ยม2,
    img4: ปลอกเสาปลอกคาน3,
    productName: "ปลอกสี่เหลี่ยม (วัตถุดิบ มอก.)",
    description : "เหล็กปลอก คือ เหล็กที่ใช้เสริมอยู่ภายในเสาหรือคานในโครงสร้างคอนกรีตเสริมเหล็ก เหล็กที่ใช้ผลิตส่วนมากคือเหล็กเส้นกลมโดยจะดัดเหล็กเส้นเป็นรูปร่างเดียวกับพื้นที่หน้าตัดของเสาหรือคานที่จะใช้ มีลักษณะเป็นเส้นกลมผิวเรียบสามารถทำเป็นรูปทรงตามที่ลูกค้าต้องการได้ เช่น สามเหลี่ยม สี่เหลี่ยม ห้าเหลี่ยม หกเหลี่ยม วงกลม รูปตัวไอ ช่วยลดเวลา ลดแรงงาน ลดค่าใช้จ่ายได้อย่างมีประสิทธิภาพ",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "11",
    img: เหล็กปลอกราง,
    img2: ตารางไซส์ลวด,
    img3: เหล็กปลอกราง2,
    img4: ปลอกเสาปลอกคาน3,
    productName: "เหล็กปลอกรางV (วัตถุดิบ มอก.)",
    description : "เหล็กปลอก คือ เหล็กที่ใช้เสริมอยู่ภายในเสาหรือคานในโครงสร้างคอนกรีตเสริมเหล็ก เหล็กที่ใช้ผลิตส่วนมากคือเหล็กเส้นกลมโดยจะดัดเหล็กเส้นเป็นรูปร่างเดียวกับพื้นที่หน้าตัดของเสาหรือคานที่จะใช้ มีลักษณะเป็นเส้นกลมผิวเรียบสามารถทำเป็นรูปทรงตามที่ลูกค้าต้องการได้ เช่น สามเหลี่ยม สี่เหลี่ยม ห้าเหลี่ยม หกเหลี่ยม วงกลม รูปตัวไอ ช่วยลดเวลา ลดแรงงาน ลดค่าใช้จ่ายได้อย่างมีประสิทธิภาพ",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "12",
    // img: ตะปู,
    img: ตะปู2,
    productName: "ตะปูตอกไม้",
    description: "ตะปูชนิดนี้นิยมใช้ในงานไม้และงานก่อสร้างจะมีหลากหลายขนาด แข็งแรงทนทาน และมีความยาวที่ไม่เท่ากัน",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "13",
    img: เสาเอ็นทับหลัง3,
    img2: ตารางไซส์ลวด,
    img3: เสาเอ็นทับหลัง2,
    img4: เสาเอ็นทับหลัง3,
    productName: "เหล็กเสาเอ็น-ทับหลังสำเร็จรูป",
    description: "เหล็กเอ็นทับหลังสำเร็จรูป คือ ผลิตภัณฑ์ใหม่ล่าสุดในวงการก่อสร้าง ทั้งบ้านพัก คอนโดมิเนียม โรงแรม โรงงาน และอื่นๆ อีกมากมาย ซึ่งสามารถติดตั้งได้ง่ายและรวดเร็วทำให้ประหยัดเวลาในการทำงาน",
    des: "- แบบ 2 เส้น",
    des2: "- แบบ 3 เส้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "14",
    img: รั้วแรงดึง,
    img2: ตารางไซส์ลวด,
    img3: รั้วแรงดึง2,
    img4: รั้วแรงดึง3,
    productName: "รั้วแรงดึง (ตาข่ายถักปม)",
    description: "รั้วแรงดึง คือ รั้วที่ใช้ในการ ล้อมอาณาเขต แบ่งแขตแดน ใช้ล้อมสัตว์ ล้อมวัว ล้อมควาย ล้อมม้า ล้อมแกะ ล้อมแพะ และสัตว์หลายประเภท ซึ่งสามารถรับแรงกระแทกได้เป็นอย่างดี",
    cat: "ลวดตาข่ายต่างๆ",
  },
  {
    _id: "15",
    img:  ลวดผูกเหล็ก1,
    // img2: ตารางไซส์ลวด,
    // img3: ลวดผูกเหล็ก1,
    // img4: ลวดผูกเหล็ก2,
    productName: "ลวดผูกเหล็ก เบอร์#18 (1.20มิล)",
    description: "ลวดผูกเหล็กหรือบางครั้งเรียกกันว่าเหล็กเบอร์ 18 คือ เหล็กเส้นที่มีขนาดเส้นผ่านศูนย์กลางเพียง 1.2 - 1.35 มิลลิเมตร มีความแข็งแรง ทนทาน แต่ก็มีความนิ่ม และเหนียว สามารถตัด ดัด ผูกยึดได้ จึงนำมาใช้เป็นส่วนประกอบในการผูกมัดเหล็กเสริมคอนกรีตอื่น ๆ เช่น เหล็กคาน เหล็กเสริมพื้น เหล็กปลอกเสา ปลอกคาน ไปจนถึงการผูกช่วงต่อเหล็กเส้น สำหรับการมาร์กจุดเชื่อมเหล็กเพื่อให้เกิดการยึดติดกันอย่างแน่นและแข็งแรงขึ้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "16",
    img:  ลวดชุบสังกะสี2,
    img2: ตารางไซส์ลวดชุบ,
    // img3: ลวดชุบสังกะสี3,
    img3: ลวดชุบสังกะสี2,
    // img4: ลวดชุบสังกะสี,
    img4: ลวดชุบสังกะสี4,
    productName: "ลวดชุบสังกะสี",
    description: "ลวดชุบสังกะสี มีลักษณะเด่นหลักๆคือมีสีขาว แวววาว ผิวสวยงาม จึงทำให้ถูกเรียกอีกชื่อหนึ่งว่า ลวดขาว นอกจากนี้ยังมีคุณสมบัติป้องกันการขึ้นสนิมและทนทานการกัดกร่อนได้ด้วย",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "17",
    img:  เหล็กวงบ่อ,
    productName: "เหล็กวงบ่อ",
    description: "ใช้สำหรับรัดรอบเสา เพื่อเพิ่มความแข็งแรงให้กับเสาคอนกรีต ช่วยต้านทานการแตกของคอนกรีตภายใน เช่น งานบ่อส้วม",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "18",
    img:  เหล็กวงท่อ,
    productName: "เหล็กวงท่อ",
    description: "เหล็กวงท่อ ผลิตโดยนำเหล็กวัตถุดิบผ่านกระบวนการเข้าเครื่องจักรอัตโนมัติที่มีความแม่นยำ สำหรับผลิตวงท่อตามขนาดที่ต้องการมาเชื่อมต่อเป็นวงกลม ใช้ในการผลิตท่อคอนกรีตเสริมแรง เช่น งานท่อน้ำ",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "19",
    img:  ตะแกรงเหล็กฉีก,
    productName: "ตะแกรงเหล็กฉีก",
    description: "ตะแกรงเหล็กฉีก คือ ตะแกรงเหล็กชนิดหนึ่งที่ผลิตด้วยกรรมวิธีการนำแผ่นเหล็กมาดึงออกหรือยืดออกเพื่อให้เกิดเป็นลวดลายขึ้นมา โดยที่แต่ละมุมของลวดลายจะติดเนียนอย่างเป็นระเบียบเป็นเนื้อเดียวกันตลอดทั้งแผ่น คุณสมบัติเด่นคือมีความแข็งแรงทนทานสามารถรองรับน้ำหนักและแรงกดทับได้อย่างดี",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "20",
    img:  เหล็กเพลท,
    img2: ตารางเหล็กเพลท,
    img3: เหล็กเพลท2,
    img4: เหล็กเพลท3,
    productName: "เหล็กเพลทตัดสำเร็จ",
    description: "แผ่นเพลท คือ แผ่นเหล็กที่ตัดมาจากเหล็กแผ่นใหญ่ด้วยเครื่องตัดที่มีมาตรฐานสูงจากโรงงานให้มีขนาดเป็นวงกลมขนาดเล็ก เหมาะกับการใช้ปิดหัวเสา รองฐานเสา และงานตกแต่งอื่นๆ",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "21",
    img:  ตะแกรงไวร์เมช,
    productName: "ไวร์เมช (ตะแกรงเหล็กเทพื้นสำเร็จรูป)",
    description: "ตะแกรงเหล็กเทพื้นสำเร็จรูปไวร์เมช หรือ ตะแกรงเหล็กกล้าเชื่อมติดเสริมคอนกรีต ผลิตโดยการนำลวดเหล็กรีดเย็นและถูกทอติดกันเป็นผืนให้มีลักษณะเหมือนตาราง ส่วนการเชื่อมอาร์กจะทำด้วยการใช้ไฟฟ้าทำให้จุดตัดทุกจุดกลายเป็นเนื้อเดียวกันอย่างสวยงาม (เพราะอยู่ในจุดหลอมละลาย) สามารถนำมาใช้แทนการผูกเหล็กเส้นธรรมดาทั่วไปได้เป็นอย่างดี ช่วยให้ประหยัดทั้งเวลาทำงานและค่าแรงงาน",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "22",
    img: สังกะสีแผ่นเรียบ,
    productName: "สังกะสีแผ่นเรียบ",
    description: "สังกะสีแผ่นเรียบ คือวัสดุที่เป็นแผ่นเหล็กซึ่งถูกเคลือบด้วยสังกะสีทั้งสองด้านโดยจะผ่านกระบวนการจุ่มร้อนอย่างต่อเนื่อง ซึ่งจะส่งผลให้มีชั้นสังกะสีเกาะติดแน่นกับเหล็กกล้าป้องกันการเกิดสนิมบนเนื้อเหล็กได้ดีขึ้น ทนต่อสภาพแวดล้อมได้มากขึ้น ยืดอายุการใช้งาน ช่วยเพิ่มความแข็งแกร่ง และยังทนทานต่อการใช้งานกลางแจ้งมากขึ้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "23",
    img: หนวดกุ้ง,
    productName: "เหล็กตัด หนวดกุ้ง",
    description: "เหล็กหนวดกุ้ง คือ เหล็กเส้นที่ยื่นออกมาจากโครงสร้างคอนกรีตเสริมเหล็กในส่วนต่างๆ เพื่อเพิ่มแรงยึดและรับแรงดึงระหว่างชิ้นส่วนสองส่วน เช่น รอยต่อของผนังกับเสาไม่ให้แยกตัวออกจากกัน ช่วยทำให้โครงสร้างแข็งแรงและยึดเกาะได้ดีขึ้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "24",
    img: เหล็กจ๊อย,
    productName: "เหล็กจ๊อย (โดเวล)",
    description: "เหล็กจ๊อย คือ เหล็กที่ทำมาจากเหล็กเส้นกลม เป็นเหล็กที่ใช้ในการสร้างถนนคอนกรีตเพื่อเสริมรอยต่อเพื่อบังคับรอยแตกให้อยู่ในจุดที่กำหนด เหล็กจ๊อยจะเข้าไปทำให้คอนกรีตรับน้ำหนักได้ดีขึ้น ช่วยกระจายการรับน้ำหนัก และช่วยพยุงตัวไม่ให้คอนกรีตแผ่นใดแผ่นหนึ่งต้องรับน้ำหนักมากเกินไป",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "25",
    img: เหล็ก2หุนลาย,
    productName: "เหล็ก 2 หุนลาย",
    description: "เหล็กเส้นกลม 2 หุน คือ เหล็กเส้นกลมที่ใช้สำหรับงานก่อสร้างที่รับแรงไม่มาก นิยมใช้ทำปลอกเสาและปลอกคานเหล็กในงานโครงสร้างเหล็กเส้นกลม เหล็กข้ออ้อย",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "26",
    img: ลวดตะปู,
    img2: ตารางไซส์ลวด,
    img3: ลวดตะปู2,
    img4: ลวดตะปู3,
    productName: "ลวดเหล็กตะปูรีดเย็น",
    description: "ลวดเหล็กตะปูรีดเย็น ผลิตโดยการนำเหล็กลวดรีดลดขนาดเส้นผ่านศูนย์กลาง ด้วยกระบวนการรีดเย็น เพื่อให้ได้ขนาดเส้นผ่านศูนย์กลางตามที่ต้องการและตรงตามมาตรฐานอุตสาหกรรมทำให้ได้ลวดเหล็กมีลักษณะกลม มีผิวเรียบ ปราศจากรอยขุดขีด ได้รูป  ไม่เป็นเหลี่ยม ไม่หยิกงอ",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "27",
    img: รั้วไวร์เมช,
    productName: "แผงรั้วสำเร็จ (รั้วไวร์เมช)",
    description: "รั้วไวร์เมช คือ รั้วที่ผลิตจากเหล็กรีดเย็นนำมาเชื่อมติดเป็นตะแกรงเหล็กแล้วชุบเคลือบด้วยสารกันสนิม เป็นรั้วที่สวยงามและทนทานต่อการสึกกร่อนสามารถติดตั้งได้ง่ายและรวดเร็ว ใช้สำหรับรั้วบ้าน โรงจอดรถ ฟิลม์อาคาร บันไดไม้สำเร็จรูป เป็นต้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "28",
    img: ไวร์รอท,
    productName: "ไวร์รอท (ลวดเหล็กคาร์บอนต่ำ)",
    description: "เหล็กไวรอทหรือไวร์รอท คือ เหล็กกล้าที่มีคาร์บอนต่ำนำไปรีดร้อนกึ่งสำเร็จรูป มีลักษณะหน้าตัดทรงกลมโดยทั่วไปมักจะนำไปดึงเย็นต่อเพื่อนำไปใช้ในอุตสาหกรรมอื่นๆ เช่น นำไปทำเป็นตะปู ลวดหนาม ตะแกรง น็อต สกรู แต่ไม่เหมาะในการนำไปใช้เป็นเหล็กเชื่อมเพื่อเสริมคอนกรีต",
    cat: "สินค้าทั่วไป",
  },
  {
    id: "29",
    img: เหล็กนั่งร้าน,
    productName: "เหล็กนั่งร้าน",
    description: "เหล็กนั่งร้าน คือ โครงสร้างชั่วคราวที่ใช้ในงานก่อสร้างและซ่อมแซม ใช้สำหรับให้ช่างก่อสร้างปีนขึ้นไปที่สูง และเหยียบขึ้นไปเพื่อทำงาน",
    des:  "- รุ่นหนา 1.70 mm. น้ำหนัก 34 กิโลกรัม",
    des2:  "- รุ่นหนา 2.00 mm. น้ำหนัก 36 กิโลกรัม",
    cat: "สินค้าทั่วไป",
  },
  {
    id: "30",
    img: กล่องเกเบี้ยน,
    productName: "กล่องเกเบี้ยน",
    description: "กล่องเกเบี้ยนได้รับความนิยมและถูกนำไปใช้งานหลากหลายรูปแบบ เช่น การตกแต่งสวนเพื่อสร้างสุนทรียภาพในการพักผ่อน การตกแต่งในพื้นที่เมือง และโครงการปรับปรุงที่ดิน นอกจากนี้ยังได้รับความนิยมนำไปใช้เพื่อสร้างกำแพง เสา ม้านั่ง ใช้ในการแบ่งพื้นที่ ใช้เสริมความแข็งแรงให้กับเนินดิน ผนัง หรือกำแพง",
    cat: "สินค้าทั่วไป",
  },
  // {
  //   id: "31",
  //   // img ,
  //   productName: "ลวดหยิกตัดตรง",
  //   description: "ลวดหยิกตัดตรงเหมาะสำหรับผลิตสานตะแกรงลวดหยิก เพื่อใช้กับงานอุตสาหกรรมต่างๆ เช่น ตะกร้าใส่ของ, กรงสัตว์เลี้ยง, ตะแกรงปิ้งย่าง, ตะแกรงวางของ",
  //   cat: "สินค้าทั่วไป",
  // },
  {
    id: "32",
    img: ลวดPC,
    productName: "ลวดPC wire เบอร์#8 (4มิล)",
    description: "ลวดPC wire หรือ Steel Wires for Pre-stressed Concrete Wire (PCW) เป็นผลิตภัณฑ์ที่ใช้ในงานก่อสร้างเนื่องจากมีคุณสมบัติทางด้านความแข็งแรงสูงกว่าเหล็กก่อสร้างทั่วๆไป โดยนำไปใช้เป็นลวดเสริมในการผลิตเสาเข็ม เสาไฟฟ้า แผ่นพื้นสำเร็จรูปและไม้หมอนคอนกรีตสำหรับรางรถไฟ",
    des: "- แบบหยัก",
    des2: "- แบบลายไข่ปลา",
    cat: "สินค้าทั่วไป",
  },
  {
    id: "33",
    img: แบบเหล็ก,
    productName: "แบบเหล็กเสา-คานเทสำเร็จ",
    description: "แบบเหล็ก คือ โครงสร้างชั่วคราวที่ทำจากเหล็กใช้สำหรับติดตั้งเป็นแบบหล่อคอนกรีตและสำหรับทำโครงสร้างและส่วนประกอบต่างของอาคาร เช่น เสา คาน",
    des: "- แบบเสามาตรฐาน (สูง3เมตร)",
    des2: "- แบบคานมาตรฐาน",
    cat: "สินค้าทั่วไป",
  }

];

// =================== ประเภทสินค้าหน้า Shop =======================

// =================== ประเภท 1 =================================

export const cat1 = [
{
  _id: "1",
  img: ปลอกเสาปลอกคาน2,
  img2: ตารางไซส์ลวด,
  img3: ปลอกเสาปลอกคาน2,
  img4: ปลอกเสาปลอกคาน3,
  productName: "ปลอกเสา-ปลอกคาน (วัตถุดิบ มอก.)",
  description: "เหล็กปลอกเสา ปลอกคาน เป็นวัสดุก่อสร้างชนิดหนึ่งที่มีการผลิตจากเหล็กเส้นกลมหรือเหล็กเส้นข้ออ้อยที่มีกำลังดึงสูง นำมาดัดโค้งเป็นรูปทรงต่างๆ เพื่อเสริมความแข็งแรงให้กับคอนกรีต ช่วยให้คอนกรีตสามารถรับแรงกดและแรงดึงได้ดียิ่งขึ้น",
  des: "- 2 หุน",
  des2: "- 3 หุน",
  cat: "เหล็กปลอกทุกชนิด Bender wire",
},
  {
    _id: "2",
    img: ปลอกสามเหลี่ยม,
    img2: ตารางไซส์ลวด,
    img3: ปลอกสามเหลี่ยม2,
    img4: ปลอกเสาปลอกคาน3,
    productName: "ปลอกสามเหลี่ยม (วัตถุดิบ มอก.)",
    description : "เหล็กปลอก คือ เหล็กที่ใช้เสริมอยู่ภายในเสาหรือคานในโครงสร้างคอนกรีตเสริมเหล็ก เหล็กที่ใช้ผลิตส่วนมากคือเหล็กเส้นกลมโดยจะดัดเหล็กเส้นเป็นรูปร่างเดียวกับพื้นที่หน้าตัดของเสาหรือคานที่จะใช้ มีลักษณะเป็นเส้นกลมผิวเรียบสามารถทำเป็นรูปทรงตามที่ลูกค้าต้องการได้ เช่น สามเหลี่ยม สี่เหลี่ยม ห้าเหลี่ยม หกเหลี่ยม วงกลม รูปตัวไอ ช่วยลดเวลา ลดแรงงาน ลดค่าใช้จ่ายได้อย่างมีประสิทธิภาพ",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "3",
    img: ปลอกสี่เหลี่ยม,
    img2: ตารางไซส์ลวด,
    img3: ปลอกสี่เหลี่ยม2,
    img4: ปลอกเสาปลอกคาน3,
    productName: "ปลอกสี่เหลี่ยม (วัตถุดิบ มอก.)",
    description : "เหล็กปลอก คือ เหล็กที่ใช้เสริมอยู่ภายในเสาหรือคานในโครงสร้างคอนกรีตเสริมเหล็ก เหล็กที่ใช้ผลิตส่วนมากคือเหล็กเส้นกลมโดยจะดัดเหล็กเส้นเป็นรูปร่างเดียวกับพื้นที่หน้าตัดของเสาหรือคานที่จะใช้ มีลักษณะเป็นเส้นกลมผิวเรียบสามารถทำเป็นรูปทรงตามที่ลูกค้าต้องการได้ เช่น สามเหลี่ยม สี่เหลี่ยม ห้าเหลี่ยม หกเหลี่ยม วงกลม รูปตัวไอ ช่วยลดเวลา ลดแรงงาน ลดค่าใช้จ่ายได้อย่างมีประสิทธิภาพ",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  },
  {
    _id: "4",
    img: เหล็กปลอกราง,
    img2: ตารางไซส์ลวด,
    img3: เหล็กปลอกราง2,
    img4: ปลอกเสาปลอกคาน3,
    productName: "เหล็กปลอกรางV (วัตถุดิบ มอก.)",
    description : "เหล็กปลอก คือ เหล็กที่ใช้เสริมอยู่ภายในเสาหรือคานในโครงสร้างคอนกรีตเสริมเหล็ก เหล็กที่ใช้ผลิตส่วนมากคือเหล็กเส้นกลมโดยจะดัดเหล็กเส้นเป็นรูปร่างเดียวกับพื้นที่หน้าตัดของเสาหรือคานที่จะใช้ มีลักษณะเป็นเส้นกลมผิวเรียบสามารถทำเป็นรูปทรงตามที่ลูกค้าต้องการได้ เช่น สามเหลี่ยม สี่เหลี่ยม ห้าเหลี่ยม หกเหลี่ยม วงกลม รูปตัวไอ ช่วยลดเวลา ลดแรงงาน ลดค่าใช้จ่ายได้อย่างมีประสิทธิภาพ",
    cat: "เหล็กปลอกทุกชนิด Bender wire",
  }
];

// =================== ประเภท 2 =================================

export const cat2 = [
  {
    _id: "1",
    img: ลวดตาข่ายทอ2,
    img2: ตารางไซส์ลวด,
    img3: ลวดตาข่ายทอ2,
    img4: ลวดตาข่ายทอ3,
    productName: "ลวดตาข่ายทอ (ตาข่ายข้าวหลามตัด)",
    hideButtons: true,
    description: "ลวดตาข่ายทอ คือ ตาข่ายที่ใช้เหล็กลวดมาถักกันเป็นช่องๆ โดยแต่ละช่องของตะแกรงจะถักเป็นรูปสี่เหลี่ยมขนมเปียกปูน จึงเรียกได้หลายชื่อ เช่น ตาข่ายถัก,ตะแกรงถัก,ตาข่ายสี่เหลี่ยมขนมเปียกปูนถักร้อยเป็นเกลียว ตาสี่เหลี่ยมขนมเปียกปูนนั่นเอง",
    cat: "สินค้าประเภทลวดตาข่าย",
  },
];

// =================== ประเภท 3 =================================

export const cat3 = [
  {
    _id: "1",
    img: ลวดหนาม,
    img2: ตารางไซส์ลวด,
    img3: ลวดหนาม2,
    img4: ลวดหนาม3,
    productName: "ลวดหนาม",
    description: "ลวดหนาม คือ เส้นลวดตีเกลียวที่มีหนามแหลมคม เกิดจากการขึ้นรูปพันเป็นเกลียวของเส้นลวดชุบสังกะสี ใช้เพื่อเพิ่มความปลอดภัยและป้องกันการบุกรุกในพื้นที่ที่ต้องการรักษาความปลอดภัย",
    cat: "ลวดหนาม Barbed wire",
  },
];

// =================== ประเภท 4 =================================

export const cat4 = [
  {
    _id: "1",
    img: ตาข่ายสาน3,
    img2: ตารางไซส์ลวด,
    img3: ตาข่ายสาน2,
    img4: ตาข่ายสาน3,
    productName: "ตาข่ายสานหยิก (ตาข่ายตัวหนอน)",
    description: "ตาข่ายลวดสานเกิดจากการนำลวดเป็นม้วนซึ่งเป็นลวดตรง มาเข้าเครื่องบดลวดให้เป็นหยักคล้ายเส้นมาม่า แล้วตัดออกเมื่อได้ตามขนาดที่ต้องการ หลังจากนั้นจึงนำลวดที่หยิกเป็นเส้นๆเหล่านี้มาสานเข้ากันเป็นตาข่ายลวดสานโดยที่อาจเข้าเครื่องสานหรือใช้มือคนสานก็ได้",
    cat: "ลวดตาข่ายต่างๆ",
  },
  {
    _id: "2",
    img: กรงไก่,
    img3: กรงไก่2,
    img4: กรงไก่3,
    productName: "ตาข่ายสี่เหลี่ยม (กรงไก่)",
    description: "ลวดตาข่ายกรงไก่ คือ ลวดตาข่ายตาสี่เหลี่ยมลวดที่มีการนำเอาเส้นลวดมาขึ้นรูปด้วยเครื่องจักรและนำมาเชื่อมให้ได้ขนาดตามช่องที่ต้องการ หลังจากนั้นนำแผ่นตาข่ายไปเข้ากระบวนการชุบกัลวาไนซ์ หรือ ชุบสังกะสี โดยปกติแล้วจะนำมาใช้งานทำเป็นกรงล้อมไก่ ล้อมสัตว์",
    des: '- ตา 1/2" (4 หุน)',
    des2: '- ตา 3/4" (6 หุน)',
    des3: '- ตา 1" (1 นิ้ว)',
    cat: "ลวดตาข่ายต่างๆ",
  },
  {
    _id: "3",
    img: รั้วแรงดึง,
    img2: ตารางไซส์ลวด,
    img3: รั้วแรงดึง2,
    img4: รั้วแรงดึง3,
    productName: "รั้วแรงดึง (ตาข่ายถักปม)",
    description: "รั้วแรงดึง คือ รั้วที่ใช้ในการ ล้อมอาณาเขต แบ่งแขตแดน ใช้ล้อมสัตว์ ล้อมวัว ล้อมควาย ล้อมม้า ล้อมแกะ ล้อมแพะ และสัตว์หลายประเภท ซึ่งสามารถรับแรงกระแทกได้เป็นอย่างดี",
    cat: "ลวดตาข่ายต่างๆ",
  },
];

// =================== ประเภท 5 =================================

export const cat5 = [
  {
    _id: "1",
    // img: ตะปู,
    img: ตะปู2,
    productName: "ตะปูตอกไม้",
    description: "ตะปูชนิดนี้นิยมใช้ในงานไม้และงานก่อสร้างจะมีหลากหลายขนาด แข็งแรงทนทาน และมีความยาวที่ไม่เท่ากัน",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "2",
    img: เสาเอ็นทับหลัง3,
    img2: ตารางไซส์ลวด,
    img3: เสาเอ็นทับหลัง2,
    img4: เสาเอ็นทับหลัง3,
    productName: "เหล็กเสาเอ็น-ทับหลังสำเร็จรูป",
    description: "เหล็กเอ็นทับหลังสำเร็จรูป คือผลิตภัณฑ์ใหม่ล่าสุดในวงการก่อสร้าง ทั้งบ้านพัก คอนโดมิเนียม โรงแรม โรงงาน และอื่นๆ อีกมากมาย ซึ่งสามารถติดตั้งได้ง่ายและรวดเร็วทำให้ประหยัดเวลาในการทำงาน",
    des: "- แบบ 2 เส้น",
    des2: "- แบบ 3 เส้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "3",
    img:  ลวดผูกเหล็ก1,
    // img2: ตารางไซส์ลวด,
    // img3: ลวดผูกเหล็ก1,
    // img4: ลวดผูกเหล็ก2,
    productName: "ลวดผูกเหล็ก เบอร์#18 (1.20มิล)",
    description: "ลวดผูกเหล็กหรือบางครั้งเรียกกันว่าเหล็กเบอร์ 18 คือ เหล็กเส้นที่มีขนาดเส้นผ่านศูนย์กลางเพียง 1.2 - 1.35 มิลลิเมตร มีความแข็งแรง ทนทาน แต่ก็มีความนิ่ม และเหนียว สามารถตัด ดัด ผูกยึดได้ จึงนำมาใช้เป็นส่วนประกอบในการผูกมัดเหล็กเสริมคอนกรีตอื่น ๆ เช่น เหล็กคาน เหล็กเสริมพื้น เหล็กปลอกเสา ปลอกคาน ไปจนถึงการผูกช่วงต่อเหล็กเส้น สำหรับการมาร์กจุดเชื่อมเหล็กเพื่อให้เกิดการยึดติดกันอย่างแน่นและแข็งแรงขึ้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "4",
    img:  ลวดชุบสังกะสี2,
    img2: ตารางไซส์ลวดชุบ,
    // img3: ลวดชุบสังกะสี3,
    img3: ลวดชุบสังกะสี2,
    // img4: ลวดชุบสังกะสี,
    img4: ลวดชุบสังกะสี4,
    productName: "ลวดชุบสังกะสี",
    description: "ลวดชุบสังกะสี มีลักษณะเด่นหลักๆคือมีสีขาว แวววาว ผิวสวยงาม จึงทำให้ถูกเรียกอีกชื่อหนึ่งว่า ลวดขาว นอกจากนี้ยังมีคุณสมบัติป้องกันการขึ้นสนิมและทนทานการกัดกร่อนได้ด้วย",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "5",
    img:  เหล็กวงบ่อ,
    productName: "เหล็กวงบ่อ",
    description: "เหล็กวงท่อ ผลิตโดยนำเหล็กวัตถุดิบผ่านกระบวนการเข้าเครื่องจักรอัตโนมัติที่มีความแม่นยำ สำหรับผลิตวงท่อตามขนาดที่ต้องการมาเชื่อมต่อเป็นวงกลม ใช้ในการผลิตท่อคอนกรีตเสริมแรง",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "6",
    img:  เหล็กวงท่อ,
    productName: "เหล็กวงท่อ",
    description: "เหล็กวงท่อ ผลิตโดยนำเหล็กวัตถุดิบผ่านกระบวนการเข้าเครื่องจักรอัตโนมัติที่มีความแม่นยำ สำหรับผลิตวงท่อตามขนาดที่ต้องการมาเชื่อมต่อเป็นวงกลม ใช้ในการผลิตท่อคอนกรีตเสริมแรง เช่น งานท่อน้ำ",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "7",
    img:  ตะแกรงเหล็กฉีก,
    productName: "ตะแกรงเหล็กฉีก",
    description: "ตะแกรงเหล็กฉีก คือ ตะแกรงเหล็กชนิดหนึ่งที่ผลิตด้วยกรรมวิธีการนำแผ่นเหล็กมาดึงออกหรือยืดออกเพื่อให้เกิดเป็นลวดลายขึ้นมา โดยที่แต่ละมุมของลวดลายจะติดเนียนอย่างเป็นระเบียบเป็นเนื้อเดียวกันตลอดทั้งแผ่น คุณสมบัติเด่นคือมีความแข็งแรงทนทานสามารถรองรับน้ำหนักและแรงกดทับได้อย่างดี",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "8",
    img:  เหล็กเพลท,
    img2: ตารางเหล็กเพลท,
    img3: เหล็กเพลท2,
    img4: เหล็กเพลท3,
    productName: "เหล็กเพลทตัดสำเร็จ",
    description: "แผ่นเพลท คือ แผ่นเหล็กที่ตัดมาจากเหล็กแผ่นใหญ่ด้วยเครื่องตัดที่มีมาตรฐานสูงจากโรงงานให้มีขนาดเป็นวงกลมขนาดเล็ก เหมาะกับการใช้ปิดหัวเสา รองฐานเสา และงานตกแต่งอื่นๆ",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "9",
    img:  ตะแกรงไวร์เมช,
    productName: "ไวร์เมช (ตะแกรงเหล็กเทพื้นสำเร็จรูป)",
    description: "ตะแกรงเหล็กเทพื้นสำเร็จรูปไวร์เมช หรือ ตะแกรงเหล็กกล้าเชื่อมติดเสริมคอนกรีต ผลิตโดยการนำลวดเหล็กรีดเย็นและถูกทอติดกันเป็นผืนให้มีลักษณะเหมือนตาราง ส่วนการเชื่อมอาร์กจะทำด้วยการใช้ไฟฟ้าทำให้จุดตัดทุกจุดกลายเป็นเนื้อเดียวกันอย่างสวยงาม (เพราะอยู่ในจุดหลอมละลาย) สามารถนำมาใช้แทนการผูกเหล็กเส้นธรรมดาทั่วไปได้เป็นอย่างดี ช่วยให้ประหยัดทั้งเวลาทำงานและค่าแรงงาน",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "10",
    img: สังกะสีแผ่นเรียบ,
    productName: "สังกะสีแผ่นเรียบ",
    description: "สังกะสีแผ่นเรียบ คือวัสดุที่เป็นแผ่นเหล็กซึ่งถูกเคลือบด้วยสังกะสีทั้งสองด้านโดยจะผ่านกระบวนการจุ่มร้อนอย่างต่อเนื่อง ซึ่งจะส่งผลให้มีชั้นสังกะสีเกาะติดแน่นกับเหล็กกล้าป้องกันการเกิดสนิมบนเนื้อเหล็กได้ดีขึ้น ทนต่อสภาพแวดล้อมได้มากขึ้น ยืดอายุการใช้งาน ช่วยเพิ่มความแข็งแกร่ง และยังทนทานต่อการใช้งานกลางแจ้งมากขึ้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "11",
    img: หนวดกุ้ง,
    productName: "เหล็กตัด หนวดกุ้ง",
    description: "เหล็กหนวดกุ้ง คือ เหล็กเส้นที่ยื่นออกมาจากโครงสร้างคอนกรีตเสริมเหล็กในส่วนต่างๆ เพื่อเพิ่มแรงยึดและรับแรงดึงระหว่างชิ้นส่วนสองส่วน เช่น รอยต่อของผนังกับเสาไม่ให้แยกตัวออกจากกัน ช่วยทำให้โครงสร้างแข็งแรงและยึดเกาะได้ดีขึ้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "12",
    img: เหล็กจ๊อย,
    productName: "เหล็กจ๊อย (โดเวล)",
    description: "เหล็กจ๊อย คือ เหล็กที่ทำมาจากเหล็กเส้นกลม เป็นเหล็กที่ใช้ในการสร้างถนนคอนกรีตเพื่อเสริมรอยต่อเพื่อบังคับรอยแตกให้อยู่ในจุดที่กำหนด เหล็กจ๊อยจะเข้าไปทำให้คอนกรีตรับน้ำหนักได้ดีขึ้น ช่วยกระจายการรับน้ำหนัก และช่วยพยุงตัวไม่ให้คอนกรีตแผ่นใดแผ่นหนึ่งต้องรับน้ำหนักมากเกินไป",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "13",
    img: เหล็ก2หุนลาย,
    productName: "เหล็ก 2 หุนลาย",
    description: "เหล็กเส้นกลม 2 หุน คือ เหล็กเส้นกลมที่ใช้สำหรับงานก่อสร้างที่รับแรงไม่มาก นิยมใช้ทำปลอกเสาและปลอกคานเหล็กในงานโครงสร้างเหล็กเส้นกลม เหล็กข้ออ้อย",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "14",
    img: ลวดตะปู,
    img2: ตารางไซส์ลวด,
    img3: ลวดตะปู2,
    img4: ลวดตะปู3,
    productName: "ลวดเหล็กตะปูรีดเย็น",
    description: "ลวดเหล็กตะปูรีดเย็น ผลิตโดยการนำเหล็กลวดรีดลดขนาดเส้นผ่านศูนย์กลาง ด้วยกระบวนการรีดเย็น เพื่อให้ได้ขนาดเส้นผ่านศูนย์กลางตามที่ต้องการและตรงตามมาตรฐานอุตสาหกรรมทำให้ได้ลวดเหล็กมีลักษณะกลม มีผิวเรียบ ปราศจากรอยขุดขีด ได้รูป  ไม่เป็นเหลี่ยม ไม่หยิกงอ",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "15",
    img: รั้วไวร์เมช,
    productName: "แผงรั้วสำเร็จ (รั้วไวร์เมช)",
    description: "รั้วไวร์เมช คือ รั้วที่ผลิตจากเหล็กรีดเย็นนำมาเชื่อมติดเป็นตะแกรงเหล็กแล้วชุบเคลือบด้วยสารกันสนิม เป็นรั้วที่สวยงามและทนทานต่อการสึกกร่อนสามารถติดตั้งได้ง่ายและรวดเร็ว ใช้สำหรับรั้วบ้าน โรงจอดรถ ฟิลม์อาคาร บันไดไม้สำเร็จรูป เป็นต้น",
    cat: "สินค้าทั่วไป",
  },
  {
    _id: "16",
    img: ไวร์รอท,
    productName: "ไวร์รอท (ลวดเหล็กคาร์บอนต่ำ)",
    description: "เหล็กไวรอทหรือไวร์รอท คือ เหล็กกล้าที่มีคาร์บอนต่ำนำไปรีดร้อนกึ่งสำเร็จรูป มีลักษณะหน้าตัดทรงกลมโดยทั่วไปมักจะนำไปดึงเย็นต่อเพื่อนำไปใช้ในอุตสาหกรรมอื่นๆ เช่น นำไปทำเป็นตะปู ลวดหนาม ตะแกรง น็อต สกรู แต่ไม่เหมาะในการนำไปใช้เป็นเหล็กเชื่อมเพื่อเสริมคอนกรีต",
    cat: "สินค้าทั่วไป",
  },
  {
    id: "17",
    img : เหล็กนั่งร้าน,
    productName: "เหล็กนั่งร้าน",
    description: "เหล็กนั่งร้าน คือ โครงสร้างชั่วคราวที่ใช้ในงานก่อสร้างและซ่อมแซม ใช้สำหรับให้ช่างก่อสร้างปีนขึ้นไปที่สูง และเหยียบขึ้นไปเพื่อทำงาน",
    des:  "- รุ่นหนา 1.70 mm. น้ำหนัก 34 กิโลกรัม",
    des2:  "- รุ่นหนา 2.00 mm. น้ำหนัก 36 กิโลกรัม",
    cat: "สินค้าทั่วไป",
  },
  {
    id: "18",
    img: กล่องเกเบี้ยน,
    productName: "กล่องเกเบี้ยน",
    description: "กล่องเกเบี้ยนได้รับความนิยมและถูกนำไปใช้งานหลากหลายรูปแบบ เช่น การตกแต่งสวนเพื่อสร้างสุนทรียภาพในการพักผ่อน การตกแต่งในพื้นที่เมือง และโครงการปรับปรุงที่ดิน นอกจากนี้ยังได้รับความนิยมนำไปใช้เพื่อสร้างกำแพง เสา ม้านั่ง ใช้ในการแบ่งพื้นที่ ใช้เสริมความแข็งแรงให้กับเนินดิน ผนัง หรือกำแพง",
    cat: "สินค้าทั่วไป",
  },
  // {
  //   id: "19",
  //   // img ,
  //   productName: "ลวดหยิกตัดตรง",
  //   description: "ลวดหยิกตัดตรงเหมาะสำหรับผลิตสานตะแกรงลวดหยิก เพื่อใช้กับงานอุตสาหกรรมต่างๆ เช่น ตะกร้าใส่ของ, กรงสัตว์เลี้ยง, ตะแกรงปิ้งย่าง, ตะแกรงวางของ",
  //   cat: "สินค้าทั่วไป",
  // },
  {
    id: "20",
    img: ลวดPC,
    productName: "ลวดPC wire เบอร์#8 (4มิล)",
    description: "ลวดPC wire หรือ Steel Wires for Pre-stressed Concrete Wire (PCW) เป็นผลิตภัณฑ์ที่ใช้ในงานก่อสร้างเนื่องจากมีคุณสมบัติทางด้านความแข็งแรงสูงกว่าเหล็กก่อสร้างทั่วๆไป โดยนำไปใช้เป็นลวดเสริมในการผลิตเสาเข็ม เสาไฟฟ้า แผ่นพื้นสำเร็จรูปและไม้หมอนคอนกรีตสำหรับรางรถไฟ",
    des: "- แบบหยัก",
    des2: "- แบบลายไข่ปลา",
    cat: "สินค้าทั่วไป",
  },
  {
    id: "21",
    img: แบบเหล็ก,
    productName: "แบบเหล็กเสา-คานเทสำเร็จ",
    description: "แบบเหล็ก คือ โครงสร้างชั่วคราวที่ทำจากเหล็กใช้สำหรับติดตั้งเป็นแบบหล่อคอนกรีตและสำหรับทำโครงสร้างและส่วนประกอบต่างของอาคาร เช่น เสา คาน",
    des: "- แบบเสามาตรฐาน (สูง3เมตร)",
    des2: "- แบบคานมาตรฐาน",
    cat: "สินค้าทั่วไป",
  }
];